// @flow

export default function (value) {
	return typeof value === 'undefined' || value === null
}
